import { FetchAPI } from "@renedelangel/helpers";

import { urlServidor } from '../../helpers';

export const GET_RESPONSABLES_SEGURO = `
    query get($filtro: InputGetResponsablesSeguro){
        getResponsablesSeguro(filtro: $filtro){
            responsableID
            responsable
        }
    }`;

export const GET_ALL_RESPONSABLES_SEGURO = `
    query filtroGetAll($filtro: InputGetResponsablesSeguro){
        getAllResponsablesSeguro(filtro: $filtro){
            responsableID
            responsable
        }
    }`;

export const TABLA_RESPONSABLES_SEGURO = `
    query filtro($filtro: InputFiltroResponsablesSeguro){
        filterResponsablesSeguro(filtro: $filtro){
            listado{
                responsableID
                responsable
            }
            registros
            paginas
        }
    }`;

export const getResponsablesSeguro = async (filtro, token) => {
    try {
        let { getResponsablesSeguro } = await FetchAPI.graphql({
            token,
            variables: { filtro },
            url: urlServidor,
            query: GET_RESPONSABLES_SEGURO
        });

        return getResponsablesSeguro;

    } catch ({ message }) { throw new Error(message); }
}

export const getAllResponsablesSeguro = async (variables, token) => {
    try {
        let { getAllResponsablesSeguro } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_RESPONSABLES_SEGURO
        });

        return getAllResponsablesSeguro;

    } catch ({ message }) { throw new Error(message); }
}

export const seleccionResponsablesSeguro = async (variables, token) => {
    try {
        let allResponsables = await getAllResponsablesSeguro(variables, token);

        if (!Array.isArray(allResponsables)) throw new Error("No se encontraron registros");

        return allResponsables.map(({ responsableID: value, responsable: label }) => ({ value, label: label.toUpperCase() }));

    } catch ({ message: label }) {
        return [{
            label,
            value: null,
            disabled: true
        }];
    }
}

export const tablaResponsablesSeguro = async (variables, token) => {
    try {
        let { filterResponsablesSeguro } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: TABLA_RESPONSABLES_SEGURO
        });
        return filterResponsablesSeguro;
    } catch ({ message }) { throw new Error(message); }
}
